// extracted by mini-css-extract-plugin
module.exports = {"autocompleteBox":"moveProjectModal_autocompleteBox__3MQIb","button":"moveProjectModal_button__OocAE"};